import types from "../types/types";

const accessToken = (attributes) => (dispatch) => {
  dispatch({
    type: types.SET_ACCESS_TOKEN,
    payload: attributes,
  });
};
export default accessToken;
